import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { responseToaster } from "../../../helperFunctions";
import DeleteModal from "../../../components/Custom/Modals/DeleteModal/DeleteModal";
import { DeleteBlockInfo } from "../../../redux/slices/blockInfoSlice";
import { useDispatch } from "react-redux";
import { useRole, useUser } from "../../../redux/slices/authSlice";
import { Table, TableRow } from "../../../components/Table";

const BlockInfoShowContent = (props) => {
  const { data, loading, onClose, onGet } = props;
  const [deleteId, setDeleteId] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filterColumns, setFilterColumns] = useState([]);
  const { user } = useUser();
  const dispatch = useDispatch();
  const role = useRole("Block Info");
  const columns = [
    {
      title: "Id",
      name: "merchantId",
    },
    {
      title: "Merchant Name",
      name: "merchantName",
    },
    {
      title: "Values",
      name: "values",
      Cell: (data) => {
        const renderValue = (key, val) => {
          if (Array.isArray(val)) {
            return (
              <div div className="d-flex button-space align-items-center">
                {(!role?.includes("blockInfo-delete") && !user?.is_Admin)
                  ? val?.join?.(", ")
                  : val?.map?.((value) => {
                    return (
                      <>
                        {value}{" "}
                        {role?.includes("blockInfo-delete") ||
                          user?.is_Admin ? (
                          <Button
                            color="danger"
                            className="btn-smallsize1"
                            onClick={() => {
                              setDeleteId({
                                key,
                                v: value,
                                k: data?.merchantId,
                              });
                            }}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </Button>
                        ) : null}
                      </>
                    );
                  })}
              </div>
            );
          } else if (typeof val === "object" && val !== null) {
            return (
              <div style={{ paddingLeft: "1rem" }}>
                {Object.entries(val).map(([key, subVal], idx) => (
                  <div key={idx}>
                    <b>{key}:</b> {renderValue(subVal)}
                  </div>
                ))}
              </div>
            );
          } else {
            return String(val);
          }
        };
        return (
          <div>
            {Object.entries?.(data?.values || {})?.map?.(([k, v], index) => (
              <div key={index} className="mb-1">
                <b>{k}:</b> {renderValue(k, v)}
              </div>
            ))}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  const onHide = () => {
    onClose();
    setDeleteId({});
    setIsLoading(false);
    onGet?.();
  };
  const onDelete = async () => {
    try {
      setIsLoading(true);
      const payload = {
        merchantId: deleteId?.k,
        columnName: deleteId?.key,
        blockData: deleteId?.v,
      };
      const res = await dispatch(DeleteBlockInfo(payload)).unwrap();
      responseToaster(res);
      if (res?.status) {
        setDeleteId({});
        onHide();
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Table
        columns={columns}
        isLoading={loading}
        data={data || []}
        isData={!!data?.length}
        filterColumns={filterColumns}
        count={data?.length || 0}
        isExpandable={false}
        onColumnsChange={(columns) => {
          setFilterColumns(columns);
        }}
      >
        {data?.map?.((item) => {
          return (
            <TableRow
              columns={columns}
              item={item}
              filterColumns={filterColumns}
              isExpandable={false}
            />
          );
        })}
      </Table>
      <DeleteModal
        title="Delete Block Info"
        content="Are you sure you want to delete this block info ?"
        isOpen={Object?.keys?.(deleteId || {})?.length}
        onDoneClick={() => onDelete()}
        onCancelClick={() => setDeleteId({})}
        isButtonLoading={isLoading}
      />
    </>
  );
};

export default BlockInfoShowContent;
